import { Alert, Button } from '@mui/material';
import React from 'react';

import { getFetchErrorMessage } from 'new/modules/settings/capsules/utils/getFetchErrorMessage';
import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesFetchErrorAlert/CapsulesFetchErrorAlert.module.scss';

export interface CapsulesFetchErrorAlertProps {
  error: unknown;
  onRetry: () => void;
}

export const CapsulesFetchErrorAlert: React.FC<CapsulesFetchErrorAlertProps> = ({
  error,
  onRetry,
}) => {
  return (
    <Alert
      severity="error"
      className={styles.alert}
      data-testid="capsules-fetch-error"
      action={
        <Button color="inherit" size="small" onClick={() => void onRetry()}>
          Retry
        </Button>
      }
    >
      {getFetchErrorMessage(error)}
    </Alert>
  );
};
